export default __webpack_public_path__ + "static/media/3rd.2408e7af.png";